/* src/app/shared/components/paid-invoices/paid-invoices.component.scss */
.paid-invoices {
  width: 100%;
  position: relative;
}
.paid-invoices__table {
  width: 100%;
}
.paid-invoices__th,
.paid-invoices__td {
  padding: 12px 16px;
}
.paid-invoices__total-label {
  text-align: right !important;
  font-weight: 600;
  opacity: 0.9;
}
.paid-invoices__total-value {
  font-weight: 700;
}
.paid_invoices__not-found {
  margin-left: 12px;
}
.mat-column-totalPaid {
  text-align: right;
}
.paid-invoices__td--amount,
.paid-invoices__th--amount {
  width: 150px;
}
.paid-invoices__view {
  text-decoration: underline;
  cursor: pointer;
}
/*# sourceMappingURL=paid-invoices.component.css.map */
